'use strict';
/**
 * ProjectStateManagerService
 * Manages the state of the projectdata in the client, allowing easy operations on it.
 * This to ensure the server/client both maintain the same project without having to communicate the complete object
 * Works fully while keeping all references
 * @author Rutger van Baren
 * @data 2018-11-30
 */

(function () {
  angular.module('specsguardApp')
    .service('ProjectStateManagerService', ProjectStateManagerService);

  ProjectStateManagerService.$inject = ['$rootScope', '$timeout', 'Constants', 'Labels'];

  function ProjectStateManagerService($rootScope, $timeout, Constants, Labels) {

    let tempId = 0;
    let watchTest = 11;

    let service = {
      project: null,
      deleteElement: deleteElement,
      appendElement: appendElement,
      updateElement: updateElement,
      query: query,
      init: init,
      subscribe: subscribe
    };

    return service;

    /**
     * Init's the service and starts watching the project
     */
    function init() {

      if ($rootScope.project) {
        service.project = $rootScope.project || {};
      }

      //@TODO find good way to detect project changes
      //$rootScope.$watch(watchProjectChange, handleProjectChange, true)
    }


    /*
    function watchProjectChange() {
      // simple solution, needs custom tweaks

      // and detemine is specific actions are required
      return JSON.stringify(service.project);
    }
    */


    /*
    function handleProjectChange(newVal, oldVal) {
        console.log('project change');
    }
    */

    /**
     * Function for external parties to subscribe to changes
     * @param scope
     * @param callback
     */
    function subscribe(scope, callback) {
      let handler = $rootScope.$on('notify-project-change', callback);
      scope.$on('$destroy', handler);
    }

    /**
     * Emits the project change event
     */
    function notify() {
      $rootScope.$emit('notify-project-change');
    }

    /**
     * Delete element from project by setting it to active: false
     * Will also update parent module & submodule active state
     * @param element
     */
    function deleteElement(element) {
      const queryElement = query(service.project.modules, {_id: element._id}, 3);

      queryElement.active = false;
      queryElement.hide = true;

      updateSubModuleActiveById(queryElement.submoduleId);
      updateModuleActiveById(queryElement.moduleId);

      notify();

      return queryElement;
    }

    /**
     * Append element to bottom up submodule
     * @param element
     * @returns {*}
     */
    function appendElement(element) {
      //find submodule
      let querySubmodule = query(service.project.modules, {_id: element.submoduleId});

      if (!element._id) {
        element._id = 'temp-' + tempId++;
      }

      querySubmodule.elements.push(element);
      querySubmodule.active = true;
      querySubmodule.hide = false;

      updateModuleActiveById(element.moduleId);

      notify();

      return element;
    }

    /**
     * Update all element data by reference
     * @param elementId
     * @param element
     */
    function updateElement(elementId, element) {
      let queryElement = query(service.project.modules, {_id: elementId});

      queryElement = Object.assign(queryElement, element);

      notify();

      return queryElement;
    }

    /**
     * Check if the module has active submodules. If it doesn't; hide it
     * @param moduleId
     */
    function updateModuleActiveById(moduleId) {
      ///find bmodule
      let queryModule = query(service.project.modules, {_id: moduleId});

      //If the module is active, check if it still has active elements after the delete
      if (queryModule.active) {
        queryModule.active = arrayHasActiveItems(queryModule.submodules);
        queryModule.hide = !queryModule.active;
      }
    }

    /**
     * Check if the submodule has active elements, if it doesn't; hide it
     * @param submoduleId
     */
    function updateSubModuleActiveById(submoduleId) {
      //find submodule
      let querySubmodule = query(service.project.modules, {_id: submoduleId});

      //If the submodule is active, check if it still has active elements after the delete

      if (querySubmodule.active) {
        querySubmodule.active = arrayHasActiveItems(querySubmodule.elements);
        querySubmodule.hide = !querySubmodule.active;
      }
    }

    /**
     * Query an array or object
     * @param arr
     * @param stack
     * @returns {*}
     */
    function query(arr, stack, maxDepth = 5, curDepth = 0) {

      if (curDepth > maxDepth) {
        return false;
      }

      if (!arr) {
        return false;
      } else if (Array.isArray(arr)) {
        for (let i = 0; arr.length - 1 >= i; i++) {
          let result = query(arr[i], stack, maxDepth, curDepth)
          if (result) { return result; }
        }
      } else if (typeof arr === 'object') {
        //First check if this is the object we are searching
        let searching = 0, found = 0;
        for (let key in stack) {
          searching++;
          if (arr[key] === stack[key]) {
            found++;
          }
        }
        // all search params matched?
        if (found === searching) {
          return arr;
        }

        for (let prop in arr) {
          let result = query(arr[prop], stack, maxDepth, curDepth + 1)
          if (result) { return result; }
        }
      }

      return false;
    }

    /**
     * Check to see if an array has active items
     * @param arr
     */
    function arrayHasActiveItems(arr) {
      for (let i = 0; arr.length - 1 >= i; i++) {
        if (arr[i].active) {
          return true;
        }
      }
      return false;
    }

  }
})();
